import React, { useEffect, useState } from "react";
import ProgressGraph from "../components/Graphs/ProgressGraph";
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import Loading from "../components/Loading/Loading";
import { MonitoringService } from "../services/MonitoringService";
import DownloadIcon from '@mui/icons-material/Download';

const HomePage = () => {
  const [activeLabelIndex, setActiveLabelIndex] = useState(-1);
  const [data, setData] = useState();
  const [notAccepted, setNotAccepted] = useState(0);
  const [noContact, setNoContact] = useState(0);

  useEffect(() => {
    MonitoringService.getDatesHomePage().then(r => {
      setData(reorganizeData(r["searchProgress"]))
      setNotAccepted(r["totalNotAccepted"])
      setNoContact(r["totalNoContact"])
    });
  }, []);

  function reorganizeData(dataToReorganize) {
    if (dataToReorganize && dataToReorganize.length === 0) return []
    if (dataToReorganize) {
      return dataToReorganize.reduce((accumulator, dataset) => {
        const { region, ageRange, ...data } = dataset;
        if (!accumulator[region]) {
          accumulator[region] = {};
        }
        if (!accumulator[region][ageRange]) {
          accumulator[region][ageRange] = {};
        }
        Object.keys(data).forEach((key) => {
          accumulator[region][ageRange][key] = (accumulator[region][ageRange][key] || 0) + data[key];
        });
        return accumulator;
      }, {});
    } else {
      return null;
    }
  }

  function TotalCalculator() {
    const key = Object.keys(data)[activeLabelIndex];
    const dataset = key ? { [key]: data[key] } : data;
    return Object.keys(dataset).reduce((accumulator, key) => {
      Object.keys(dataset[key]).forEach((age) => {
        accumulator[age] = accumulator[age] || {};
        Object.keys(dataset[key][age]).forEach((key2) => {
          accumulator[age][key2] = (accumulator[age][key2] || 0) + dataset[key][age][key2];
        });
      });
      return accumulator;
    }, {});
  }

  function RenderGraph(sex) {
    let dataSelect = {};
    const keys = Object.keys(data);
    if (activeLabelIndex === -1) {
      dataSelect = TotalCalculator();
    } else {
      dataSelect = data[keys[activeLabelIndex]];
    }
    return (
      <div>
        <div className="flex flex-wrap justify-center pt-2 -mx-4">
          {Object.keys(dataSelect).map((age, rowIndex) => (
            <div key={rowIndex} className="px-2 mb-2 ">
              <ProgressGraph
                legend={age}
                percent={PercentageCalculator(dataSelect[age], sex.data)}
                sex={sex.data}
                size={120}
              />
            </div>
          ))}
          <div className={`px-8 mx-4 pb-2 border-0 lg:border-l lg:border-r inline ${sex.data === "Female" ? '-mt-12 pt-12' : ''}`}>
            <ProgressGraph
              legend="Total"
              percent={PercentageCalculator(dataSelect, sex.data)}
              sex={sex.data}
              size={135}
            />
          </div>
        </div>
      </div>
    );
  }

  function PercentageCalculator(row, sex) {
    const remaining = sex === "Male" ? "remainingM" : "remainingF"
    const total = sex === "Male" ? "totalM" : "totalF"
    let results = []
    if (row[total] === undefined || row[remaining] === undefined) {
      let totals = 0
      let remainings = 0
      Object.keys(row).forEach((key) => {
        totals += row[key][total]
        remainings += row[key][remaining]
      });
      if (totals === 0) return -1
      results.push(remainings)
      results.push(totals)
      return results
    }
    if (row[total] === 0) return -1
    results.push(row[remaining])
    results.push(row[total])
    return results
  }

  function RenderIndividualRegionGraphs() {
    return (
      <div className="w-10/12 text-left flex flex-col xl:flex-row justify-center">
        <div className="">
          <div className="border-b-1 my-4">
            <label className="font-medium">Masculino</label>
            <RenderGraph data={"Male"} />
          </div>

          <div className="border-b-4 lg:border-none ">
            <label className="font-medium">Feminino</label>
            <RenderGraph data={"Female"} />
          </div>

        </div>
        <div className="w-full xl:w-2/12 pt-5 xl:pt-0 lg:mx-2">
          <ProgressGraph
            legend={"Total geral"}
            percent={TotalCalculator()}
            sex={"Total"}
            size={150}
          />
        </div>
      </div>
    )
  }

  if (data && data.length === 0) {
    return (
      <>
        <div className='flex-1 w-full h-screen overflow-auto bg-[#fff]  flex flex-col justify-center text-secondary items-center  text-center '>
          <h4 className="text-2xl font-semibold">Andamento da pesquisa</h4>
          <h5>Nenhum dado a ser apresentado</h5>
          <div
            className='flex justify-center flex-col text-center items-center my-5'>
            <SentimentDissatisfiedIcon fontSize=''
              className='text-9xl mb-5' />
            <h1 className='text-2xl font-normal'>Lamento, parece que houve algum problema </h1>
            <h6 className="text-primary font-bold">Tente novamente mais tarde</h6>
          </div>
          <div className='flex justify-center w-full select-none'>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      {data ?
        <div className="flex-1 h-full pt-14 flex flex-col items-center select-none overflow-auto">
          <h4 className="text-2xl font-semibold">Andamento da pesquisa</h4>
          <div className="flex flex-wrap justify-center my-2 w-10/12">
            {Object.keys(data).map((region, rowIndex) => (((label, index) => (
              <button key={index} className={`m-1 px-4 py-2 rounded hover:bg-gray-300 ${activeLabelIndex === index
                ? "bg-primary text-white"
                : "bg-gray-200 text-gray-800"
                }`}
                onClick={() => setActiveLabelIndex(index)}
              >
                {label}
              </button>
            ))(region, rowIndex)),
            )}
            <button className={`m-1 px-4 py-2 rounded hover:bg-gray-300 
                    ${activeLabelIndex === -1
                ? "bg-primary text-white"
                : "bg-gray-200 text-gray-800"
              }`}
              onClick={() => setActiveLabelIndex(-1)}
            >
              Total
            </button>
          </div>
          <RenderIndividualRegionGraphs />
          <div className="w-7/12">
            <hr />

          </div>

          <div className="w-10/12 mb-8">
            <div className="flex flex-col items-center justify-center my-8">
              <button className="border-bg-emerald-300 my-4  px-4 py-2 rounded-lg border bg-primary text-white tracking-wider select-none cursor-pointer hover:bg-dark-primary duration-150 ease-in-out" onClick={MonitoringService.downloadListFinished}><DownloadIcon /> Lista de entrevistados</button>
            </div>
            <p className="text-center text-xl my-4 font-semibold ">Vieses da pesquisa</p>
            <div className="flex flex-col items-center justify-center">
              <div className="flex my-1 justify-between w-full md:w-1/3">
                <p className="text-left">Registros de não consentimento:</p>
                <p className="text-right">{notAccepted}</p>
              </div>
              <div className="flex my-1 justify-between w-full md:w-1/3">
                <p className="text-left">Registros de inviabilidade de entrevista:</p>
                <p className="text-right">{noContact}</p>
              </div>
            </div>

          </div>
        </div>
        :
        <div className="flex-1 flex w-full justify-center items-center overflow-auto">
          <Loading/>
        </div>
      }
    </>
  );
};

export default HomePage;
